// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"FuncionarioDashboard_dashboardContainer__Ei2LD","gridContainer":"FuncionarioDashboard_gridContainer__0GuFg"};